module.exports = __webpack_public_path__ + "img/地龙.300204de.jpg";